import React, { useState } from 'react';
import { AddTeamMemberRequest, TeamMemberResponse } from '../models/api';
import Button from './Button';
import Feedback from './Feedback';

type TeamMembersFormProps = {
  model: TeamMemberResponse | null | undefined;
  submit: (e: AddTeamMemberRequest) => Promise<boolean>;
  isSubmitting: boolean;
  errors: string[];
  close: () => void;
  buttonText: string;
};

const TeamMembersForm: React.FC<TeamMembersFormProps> = ({
  model,
  submit,
  isSubmitting,
  errors,
  close,
  buttonText
}) => {
  const [emailAddress, setEmailAddress] = useState(model?.emailAddress ?? '');

  const handle = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const result = await submit({
      emailAddress
    });

    if (result) {
      setEmailAddress('');
    }
  };

  return (
    <form onSubmit={handle} className="content-form">
      <div className="field">
        <label htmlFor="name">Email Address</label>
        <input
          id="email"
          type="email"
          placeholder="Email Address"
          value={emailAddress}
          onChange={(e) => setEmailAddress(e.target.value)}
          readOnly={!!model}
        />
      </div>
      <div className="button-container">
        <Button
          className="action-button"
          isLoading={isSubmitting}
          isSubmit={true}
        >
          {buttonText}
        </Button>
        <button type="button" className="cancel-button" onClick={() => close()}>
          Cancel
        </button>
      </div>
      <Feedback messages={errors} type="error" />
    </form>
  );
};

export default TeamMembersForm;
